import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter, Redirect } from 'react-router-dom';
import Div100vh from 'react-div-100vh';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import GlobalStyle from './GlobalStyle';
import LargeHeader from '../LargeHeader';
import SmallHeader from '../SmallHeader';
import Footer from '../Footer';
import DollarRedemptionBox from '../DollarRedemptionBox';

const Main = styled.main`
  min-height: 50%;
  background: linear-gradient(180deg, rgba(129, 17, 21, 1) 0%, rgba(237, 28, 36, 1) 10px);
`;

const LoaderWrapper = styled(Div100vh)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: rgba(237, 28, 36, 1);
`;

const Spinner = styled(FontAwesomeIcon)`
  margin-bottom: 16px;
`;

const Layout = ({ location, member, loading, children }) => {
  const { pathname } = location;

  console.log('member', member);

  const mDollar = _.get(member, 'meta.monopoly.points', 0);

  const calculateRedemptionChance = point => {
    return Math.floor(point / 300);
  };

  if (loading === true) {
    return (
      <LoaderWrapper>
        <GlobalStyle />
        <Spinner icon={faSpinner} spin size="4x" />
        <div>加載中...</div>
      </LoaderWrapper>
    );
  } else if (!member && !loading && pathname !== '/redirectToMme') {
    return <Redirect to="/redirectToMme" />;
  } else if (pathname === '/coupon' || pathname === '/coupons') {
    return (
      <Div100vh>
        <GlobalStyle />
        <SmallHeader />
        <DollarRedemptionBox
          mDollar={mDollar}
          redemptionChance={calculateRedemptionChance(mDollar)}
        />
        <Main>{children}</Main>
        <Footer />
      </Div100vh>
    );
  } else {
    return (
      <Div100vh>
        <GlobalStyle />
        <LargeHeader />
        <DollarRedemptionBox
          mDollar={mDollar}
          redemptionChance={calculateRedemptionChance(mDollar)}
        />
        <Main>{children}</Main>
        <Footer />
      </Div100vh>
    );
  }
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object,
  member: PropTypes.object,
  loading: PropTypes.bool,
};

export default withRouter(Layout);
